import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { CustomColumnSettingsEntryRemoteDto } from 'src/generated/signalR/custom-column-settings-entry-remote-dto';
import { CustomColumnSettingsUpdated } from './custom-column-names.actions';
import { SettingsState } from '../../settings/settings.state';
import { LanguageType } from 'src/app/samwebDescription/samweb/settings/language-types';

export interface CustomColumnNamesStateModel {
   customColumnSettings: CustomColumnSettingsEntryRemoteDto[];
}
@State<CustomColumnNamesStateModel>({
   name: 'customColumnNames',
   defaults: {
      customColumnSettings: [],
   },
})
@Injectable()
export class CustomColumnNamesState {
   @Selector([CustomColumnNamesState, SettingsState.getCurrentLanguage])
   public static getCustomColumnSettings(state: CustomColumnNamesStateModel, language: LanguageType): CustomColumnSettingsEntryRemoteDto[] {
      return state.customColumnSettings.filter((settings) => settings.languageId === language.samwinLegacyLanguageCode);
   }
   @Action(CustomColumnSettingsUpdated)
   public customColumnSettingsUpdated(ctx: StateContext<CustomColumnNamesStateModel>, action: CustomColumnSettingsUpdated) {
      ctx.patchState({
         customColumnSettings: action.data.columnSettings?.columnSettings ?? [],
      });
   }
}
